function Quote() {
    return (
      <section style={{ background: "#e6f0ff", textAlign: "center", fontWeight: "bold", fontSize: "20px", color: "#003366" }}>
        "Pumping energy into our adventures"
      </section>
    );
  }
  export default Quote;